module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "审核状态"
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboData.auditState), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.handleCellStyle,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.mainTableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年",
      "prop": "year",
      "align": "center",
      "min-width": "25%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "毕业标准类型",
      "prop": "standardType",
      "formatter": _vm.standardTypeFormatter,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "毕业标准",
      "prop": "standardRatio",
      "formatter": _vm.standardRatioFormatter,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交状态",
      "prop": "submitState",
      "formatter": _vm.submitStateFormatter,
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "prop": "auditState",
      "formatter": _vm.auditStateFormatter,
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "25%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.submitState == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.showGraduateStuList('set', scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 学生名单\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.submitState == '1' && scope.row.auditAuth == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.showGraduateStuList('view', scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 学生名单\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.auditAuth == '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showGraduateStuList('audit', scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 审核\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.submitState == '1' || scope.row.auditState != '') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showAuditList(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document"
        }), _vm._v(" 审核信息\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "1500px",
      "top": _vm.dialogTop
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "700px"
    }
  }, [_c('graduateStu', {
    ref: "graduateStu",
    attrs: {
      "graduateParam": _vm.graduateParam
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "updateDialogTitle": _vm.updateDialogTitle
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "900px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.graduateParam.mainCode,
      "listHeight": 450,
      "auditFlowInfo": _vm.auditFlowInfo
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0385a037"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baseInfo/student/graduate.vue
// module id = 1766
// module chunks = 502